/* eslint-disable camelcase */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Breadcrumb, BreadcrumbItem } from '@patternfly/react-core';
import { Link } from 'react-mobx-router5';
import { CatalogLayout } from '@ole-ui/ole-ui-components';
import { Helmet } from 'react-helmet';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import Filters from 'components/Classes/LiveClass/LiveClassFilter';
import LiveClassDescription from 'components/Classes/LiveClass/LiveClassDescription';
import OfferingLiveClassList from 'components/Classes/LiveClass/LiveClassList';
import { storesContext } from 'stores';
import './styles.scss';

const ScheduleLiveClass = () => {
  const { t } = useTranslation();
  const { routerStore, liveClassStore, catalogStore } =
    useContext(storesContext);

  const route = routerStore?.route as any;
  const pageTitle = route?.params?.title;

  return (
    <>
      <Helmet title={`${pageTitle} - Red Hat Learning`} />
      <CatalogLayout>
        <CatalogLayout.Filters>
          <Filters showSeatsFilter title={t('Schedule live Class')} />
        </CatalogLayout.Filters>

        <CatalogLayout.Content>
          <div className="live-class-breadcrumb">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link
                  href
                  routeName="catalog"
                  routeParams={catalogStore.lastCatalogParams}
                  data-analytics-id="catalog-href-liveclass-schedule-lp"
                >
                  {t('Catalog')}
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem isActive>
                {t('Live classes for {{offering}}', {
                  offering:
                    liveClassStore.offeringCode?.toUpperCase?.() ??
                    liveClassStore.offeringCode,
                })}
              </BreadcrumbItem>
            </Breadcrumb>
          </div>

          <LiveClassDescription />
          <OfferingLiveClassList />
        </CatalogLayout.Content>
      </CatalogLayout>
    </>
  );
};

export default withErrorBoundary(
  observer(ScheduleLiveClass),
  GenericViewError,
  handleError,
);
